import { render, staticRenderFns } from "./MetadataDetail.vue?vue&type=template&id=3a05b960&"
import script from "./MetadataDetail.vue?vue&type=script&lang=js&"
export * from "./MetadataDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports